import { films } from "@/mocks/films";
import { editorPicks } from "@/mocks/siteContent";
import SectionHeading from "./SectionHeading";

export default function EditorPicksSection() {
  return (
    <section id="picks" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="编辑精选"
          title="本期编辑手记：如果只挑三部，我们会这样推荐"
          desc="榜单告诉你大家在看什么，编辑手记则回答「为什么值得看」。下面三部各代表一种观看需求，配上一段具体的观看建议，帮你判断现在适不适合打开它。"
        />

        <div className="mt-10 flex flex-col gap-10 md:gap-14">
          {editorPicks.map((pick, index) => {
            const film = films.find((f) => f.id === pick.filmId);
            if (!film) return null;
            const reverse = index % 2 === 1;
            return (
              <article key={pick.filmId} className="grid grid-cols-1 items-center gap-6 md:gap-10 lg:grid-cols-12">
                <div className={`lg:col-span-5 ${reverse ? "lg:order-2" : ""}`}>
                  <div className="aspect-[4/3] w-full overflow-hidden rounded-lg bg-background-200">
                    <img src={film.cover} alt={`${film.title} 剪影`} className="h-full w-full object-cover object-top" />
                  </div>
                </div>
                <div className={`lg:col-span-7 ${reverse ? "lg:order-1" : ""}`}>
                  <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-800">
                    <i className="ri-pencil-line"></i>
                    {pick.label}
                  </span>
                  <h3 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">{film.title}</h3>
                  <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-2 text-sm text-foreground-500">
                    <span className="flex items-center gap-1 font-heading text-xl text-primary-700">
                      <i className="ri-star-fill text-sm"></i>
                      {film.rating.toFixed(1)}
                    </span>
                    <span aria-hidden="true">·</span>
                    <span>{film.year}</span>
                    <span aria-hidden="true">·</span>
                    <span>{film.region}</span>
                    <span aria-hidden="true">·</span>
                    <span>{film.genre}</span>
                    <span aria-hidden="true">·</span>
                    <span>{film.duration}</span>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-600">{film.summary}</p>
                  <blockquote className="mt-4 border-l-2 border-primary-400 bg-background-50 px-4 py-3 text-sm leading-relaxed text-foreground-700">
                    {pick.note}
                  </blockquote>
                  <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-user-star-line"></i>
                      导演 {film.director}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-eye-line"></i>
                      {film.views} 次浏览
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}